import { ReactComponent as ArrowIcon } from "assets/icons/down-arrow.svg";
import { spacing } from "globalStyles";
import useToggleOpen from "hooks/useToggleOpen";
import React, { ReactNode } from "react";
import styled from "styled-components";

export const CARD_ARROW_WIDTH = 17;
const ANIMATION_DURATION = 0.5;

type CardListColor = "primary";

interface Props {
  children: ReactNode;
  color?: CardListColor;
  className?: string;
  ExtraInfo?: ReactNode;
  extraInfoApproximateMaxHeight?: number;
}

const Card: React.FC<Props> = ({
  children,
  color = "primary",
  ExtraInfo,
  extraInfoApproximateMaxHeight = 750,
  className,
}) => {
  const { isOpen, toggleOpen } = useToggleOpen();

  return (
    <Container color={color} className={className} onClick={toggleOpen}>
      {!ExtraInfo ? (
        children
      ) : (
        <ContentContainer>
          <CardContainer>
            {children}
            <Arrow $opened={isOpen} />
          </CardContainer>
          <ExtraInfoContainer
            extraInfoApproximateMaxHeight={extraInfoApproximateMaxHeight}
            $opened={isOpen}
          >
            {ExtraInfo}
          </ExtraInfoContainer>
        </ContentContainer>
      )}
    </Container>
  );
};

export default Card;

const Container = styled.div<{ color: CardListColor }>`
  background-color: ${({ theme, color }) => theme.colors.cardsList[color].background};
  padding: ${spacing.small}px ${spacing.medium}px;
  box-shadow: 0px 3px 6px #00000029;
  cursor: pointer;

  :hover {
    background-color: ${({ theme, color }) => theme.colors.cardsList[color].hover};
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const CardContainer = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
`;

const Arrow = styled(ArrowIcon)<{ $opened: boolean }>`
  transform: ${({ $opened }) => ($opened ? `rotate(180deg)` : `rotate(0deg)`)};
  transition: transform ${ANIMATION_DURATION}s ease;
  stroke: ${({ theme }) => theme.colors.accordion.primary.arrowColor};
  width: ${CARD_ARROW_WIDTH}px;
`;

const ExtraInfoContainer = styled.div<{
  $opened: boolean;
  extraInfoApproximateMaxHeight: number;
}>`
  width: 100%;
  display: flex;
  overflow: hidden;
  transition: max-height ${ANIMATION_DURATION}s ease;
  max-height: ${({ $opened, extraInfoApproximateMaxHeight }) =>
    $opened ? `${extraInfoApproximateMaxHeight}px` : 0};
`;
